import { Model } from './model';

export class User extends Model {
  id: string;

  default_email_sender_id: string | null;

  email: string;

  given_name: string;

  is_access_approved: boolean;

  is_acc_disabled: boolean;

  is_org_admin: boolean;

  is_support_user: boolean;

  role: UserRoleLevel;

  onboarding_required: boolean;

  family_name: string;

  name: string;

  organization_id: string;

  profile_picture: string | null;

  dashboard_settings: {
    thread_emails_sort_order: string;
  };

  get initials(): string {
    if (this.name) {
      return this.name
        .trim()
        .split(' ')
        .slice(0, 2)
        .map((n) => n.substring(0, 1))
        .join('');
    }

    return this.given_name && this.family_name
      ? `${this.given_name.substring(0, 1)}${this.family_name.substring(0, 1)}`
      : '';
  }

  get displayName(): string {
    return `${this.given_name || ''} ${this.family_name || ''}`.trim();
  }

  get userRole(): UserRoleLevel {
    return this.role ?? (this.is_org_admin ? UserRoleLevel.Admin : UserRoleLevel.Member);
  }

  get roleLabel(): string {
    return UserRoleLabels[this.userRole];
  }

  get state(): UserState {
    return this.is_acc_disabled
      ? UserState.Deactivated
      : this.is_access_approved
        ? UserState.Active
        : UserState.Pending;
  }

  get stateLabel(): string {
    return UserStateLabels[this.state];
  }
}

export enum UserRoleLevel {
  Admin = 'admin',
  Member = 'member',
  Manager = 'manager',
}

export const UserRoleLabels: Record<UserRoleLevel, string> = {
  [UserRoleLevel.Admin]: 'Admin',
  [UserRoleLevel.Member]: 'Member',
  [UserRoleLevel.Manager]: 'Manager',
};

export enum Capability {
  EditTemplates = 'edit_templates',
}

export enum UserState {
  Pending = 'pending',
  Active = 'active',
  Deactivated = 'deactivated',
}

export const UserStateLabels: Record<UserState, string> = {
  [UserState.Pending]: 'Pending Approval',
  [UserState.Active]: 'Active',
  [UserState.Deactivated]: 'Deactivated',
};

export interface UserGroup {
  label: string;
  users: User[];
}

export interface UserRole {
  name: string;
  description: string;
  value: UserRoleLevel;
}

export interface UserAssignmentStats {
  num_assigned_partners: number;
  num_assigned_tasks: number;
}

export const USER_ROLES: UserRole[] = [
  {
    name: UserRoleLabels[UserRoleLevel.Member],
    description: 'Can view data.',
    value: UserRoleLevel.Member,
  },
  {
    name: UserRoleLabels[UserRoleLevel.Admin],
    description: 'Can view data, grant user access, update user roles, and manage billing.',
    value: UserRoleLevel.Admin,
  },
  {
    name: UserRoleLabels[UserRoleLevel.Manager],
    description: 'Can view all activity for their assigned business unit.',
    value: UserRoleLevel.Manager,
  },
];

export type PartnerInvoiceUserAssignmentType = 'all' | 'unassigned' | 'none';
